module.exports = __webpack_public_path__ + "static/logo-northwell-new-9d829fb1760b5fcdeb90e4f49d639f07.png";